<div class="game-panel-menu-container">
  <div class="grid-cols-5 gap-4 md:grid">
    <app-menu-card-v2
      *ngFor="let dealer of dealers; trackBy: trackByDealer"
      [dealer]="dealer"
      [isLoggerPage]="true"
      [onClickLoggerPage]="updateDealerTable.bind(this)"
    ></app-menu-card-v2>
  </div>
</div>
